module.exports = __webpack_public_path__ + "img/hair_franchise_splash.e7ed7ec4.jpg";